module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8011.49cb4845.png";